import { IconButton, HStack } from '@chakra-ui/react'
import { FC, useMemo } from 'react'

import useTable from '@hook/shared/use-table'

import { ITableGridRow } from '@base/@types/components/Layout/TableGrid'

interface ITableGridItemOtbFollowUp {
  [key: string]: any
  updateIsGraphic?: (data: any) => void
}

export const TableGridItemOtbFollowUp: FC<ITableGridItemOtbFollowUp> = ({
  data,
  updateIsGraphic
}) => {
  const { actions, columns } = useTable()

  const handleUpdateIsGraphic = (target: any) => {
    const tagName = target.parentNode.parentNode.tagName
    const tagButtonName = target.parentNode.tagName
    const element = document.querySelector('.select-line')
    !!element && element.classList.remove('select-line')

    if (tagName === 'TR') {
      target.parentNode.parentNode.className = 'select-line'
    }

    if (tagName === 'TBODY') {
      target.parentNode.className = 'select-line'
    }

    if (
      tagButtonName !== 'svg' &&
      tagButtonName !== 'BUTTON' &&
      tagButtonName !== 'DIV'
    ) {
      !!updateIsGraphic && updateIsGraphic(data)
    }
  }

  const rows = useMemo<ITableGridRow[]>(() => {
    const res = []
    for (const column of columns) {
      if (column.columns && column.columns.length > 0) {
        for (const row of column.columns) {
          res.push({
            id: row.id,
            value: data[row.id],
            align: row.align || 'left'
          })
        }
      } else {
        res.push({
          id: column.id!,
          value: data[column.canPrint ? column.id! : column.group],
          align: column.align || 'left'
        })
      }
    }
    return res
  }, [columns, data])

  return (
    <tr
      className={'show-icon'}
      onClick={({ target }) => handleUpdateIsGraphic(target)}
    >
      {actions && actions.length > 0 && (
        <td>
          <HStack
            w="100%"
            spacing={2}
            alignItems="center"
            justifyContent="center"
          >
            {actions.map((action, index) => {
              if (action.type === 'icon' && !action.onFocus) {
                return (
                  <IconButton
                    h={6}
                    key={`table-action-${index}`}
                    aria-label="Abrir modal"
                    icon={action.icon}
                    size="md"
                    onClick={() => action.onSelect!(data)}
                    _hover={{
                      bg: 'yellow.200'
                    }}
                    _active={{
                      bg: 'yellow.100'
                    }}
                  />
                )
              }

              if (action.onFocus) {
                return (
                  <IconButton
                    h={2}
                    className="icon-button-modal"
                    key={`table-action-${index}`}
                    aria-label="Icon modal"
                    icon={action.icon}
                    size="md"
                  />
                )
              }
            })}
          </HStack>
        </td>
      )}

      {rows.map(({ id, value, align }, key) => (
        <td
          id={id}
          className="td-element"
          key={`${id}-${key}`}
          align={align || 'left'}
        >
          <div>{value}</div>
        </td>
      ))}
    </tr>
  )
}
